import styled from '@emotion/styled';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 16px;
`;

export const CustomerFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  gap: 12px;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LastEditTypographyHeader = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  color: #919eab;
  cursor: default;
`;

export const DeleteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  justify-content: flex-end;
  gap: 14px;

  &:hover {
    #delete_text,
    #delete_icon {
      color: #db1e1e;
    }
  }
`;
